import { type Type_ITaskReport, Type_toDisplayUnitUuid } from '../Type/Type.hive'

export function UF_migrateUnitFormToUuids(taskReport: Type_ITaskReport) {
    if (taskReport.report.type !== 'unit-form') return taskReport

    taskReport.report.displayUnits.forEach(
        (displayUnit) => (displayUnit.instanceId = Type_toDisplayUnitUuid(displayUnit.unit.id.toString()))
    )

    taskReport.report.sections.forEach(
        (section) =>
            (section.sectionProducts = section.sectionProducts.map(
                (
                    id: any // pre-migration ids are numbers
                ) => Type_toDisplayUnitUuid(id.toString())
            ))
    )

    return taskReport
}
